import "../../css/master.css";
import "../../css/app.css";
import "../../css/custom.css";
import { useAtom, atom } from 'jotai';
import Loader from '../../loader/loader';
import MainComponent from "./main_component";

const isLoadingAtom = atom(false);

function InpuKanjiName({ AuthVerify }) {

    const [isLoading, setIsLoading] = useAtom(isLoadingAtom);

    const handleLoading = (set) => {

        setIsLoading(set)
    }

    return (
        <>
            <AuthVerify />
            <div>
                {isLoading === true ? <Loader /> : null}
                <MainComponent handleLoading={handleLoading} />
            </div>
        </>
    );
}


export default InpuKanjiName;